import { ReactNode } from "react";

import { Buildings } from "@phosphor-icons/react";
import { Input, Label } from "@reactive-resume/ui";

import { useCoverLetterStore } from "@/client/stores/cover-letter";
import { CLCollapsibleSection } from "../../CollapsibleSection";

export const RecipientSection = () => {
  const setValue = useCoverLetterStore((state) => state.setValue);
  const recipient = useCoverLetterStore((state) => state.coverLetter.data.recipient);

  const headerHTML: ReactNode = (
    <div className="flex items-center gap-x-4">
      <Buildings size={18} />
      <h2 className="line-clamp-1 text-base font-bold text-gray-800 lg:text-xl">Recipient</h2>
    </div>
  );

  const contentHTML: ReactNode = (
    <main className="grid gap-4 sm:grid-cols-2">
      <div className="space-y-1.5 sm:col-span-2">
        <Label>Recipient Name</Label>
        <Input
          placeholder="Jane Smith"
          value={recipient.name}
          onChange={(event) => setValue("recipient.name", event.target.value)}
        />
      </div>

      <div className="space-y-1.5">
        <Label>Title / Position</Label>
        <Input
          placeholder="Hiring Manager"
          value={recipient.title}
          onChange={(event) => setValue("recipient.title", event.target.value)}
        />
      </div>

      <div className="space-y-1.5">
        <Label>Company</Label>
        <Input
          placeholder="Acme Corp"
          value={recipient.company}
          onChange={(event) => setValue("recipient.company", event.target.value)}
        />
      </div>

      <div className="space-y-1.5">
        <Label>Department</Label>
        <Input
          placeholder="Engineering"
          value={recipient.department}
          onChange={(event) => setValue("recipient.department", event.target.value)}
        />
      </div>

      <div className="space-y-1.5">
        <Label>Address</Label>
        <Input
          placeholder="123 Main St, City, State"
          value={recipient.address}
          onChange={(event) => setValue("recipient.address", event.target.value)}
        />
      </div>
    </main>
  );

  return (
    <CLCollapsibleSection id="cl-recipient" header={headerHTML} content={contentHTML} />
  );
};
